import { render, staticRenderFns } from "./Dashboarders.vue?vue&type=template&id=2d730f94"
import script from "./Dashboarders.vue?vue&type=script&lang=js"
export * from "./Dashboarders.vue?vue&type=script&lang=js"
import style0 from "./Dashboarders.vue?vue&type=style&index=0&id=2d730f94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports